import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from 'components/footers/FiveColumnWithInputForm.js';
import './style.css';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

const PaymentAdmin = () => {
  const { t, i18n } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    perPage: 10,
  });
  const [isAdmin, setIsAdmin] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const paymentStatuses = [
    { value: 'payé', label: t('Paye') },
    { value: 'annulé', label: t('Annule') },
  ];

  useEffect(() => {
    checkAdminStatus();
  }, []);

  useEffect(() => {
    if (isAdmin) {
      fetchAllOrders(pagination.currentPage);
    }
  }, [pagination.currentPage, isAdmin]);

  const checkAdminStatus = () => {
    const isAdmin = localStorage.getItem('isAdmin') === '1';
    setIsAdmin(isAdmin);

    if (isAdmin) {
      fetchAllOrders(pagination.currentPage);
    }
  };

  const fetchAllOrders = async (page) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;

      const response = await axios.get(
        `https://elanciabioapi.com/api/admin/orders?page=${page}&per_page=${pagination.perPage}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const or = response.data.data;
        setOrders(or);
        setPagination((prev) => ({
          ...prev,
          totalPages: response.data.last_page || 1,
        }));
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  const handlePaymentStatus = async (orderId, status) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;

      const response = await axios.put(
        `https://elanciabioapi.com/api/admin/orders/${orderId}/payment-status`,
        { PaymentStatus: status },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        fetchAllOrders(pagination.currentPage);
      }
    } catch (error) {
      console.error('Error updating payment status:', error);
    }
  };

  const handleView = (orderID) => {
    const order = orders.find((order) => order.OrderID === orderID);
    if (normalizeStatus(order?.status) === 'livre') {
      handlePaymentStatus(order.OrderID, 'payé');
    } else {
      Swal.fire({
        icon: 'warning',
        title: t('Attention'),
        text: t('Order_not_delivered_message'),
      });
    }
  };

  const handleDelete = (orderID) => {
    const order = orders.find((order) => order.OrderID === orderID);
    if (normalizeStatus(order?.status) === 'livre') {
      handlePaymentStatus(order.OrderID, 'annulé');
    } else {
      Swal.fire({
        icon: 'warning',
        title: t('Attention'),
        text: t('Order_not_delivered_message'),
      });
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.totalPages) {
      setPagination((prev) => ({
        ...prev,
        currentPage: page,
      }));
    }
  };

  const getTranslatedText = (value) => {
    if (typeof value === 'object' && value !== null) {
      return value[i18n.language] || Object.values(value)[0] || '';
    }
    return value;
  };

  const normalizeStatus = (status) => {
    return status?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') || '';
  };

  if (!isAdmin) {
    return <p className="text-danger text-center">{t('Unauthorized_message')}</p>;
  }

const getProductName = (productName) => {
  if (!productName) return '';
  try {
    // First, remove the extra quotes
    const firstParse = JSON.parse(productName);
    // Then parse the inner JSON
    const parsed = JSON.parse(firstParse);
    return parsed[i18n.language] || parsed.fr || '';
  } catch (error) {
    console.error('Error parsing product name:', productName, error);
    return productName; // fallback
  }
};

  return (
    <AnimationRevealPage>
      <LightAdmin />
      <div className="d-flex flex-column flex-md-row">
        <section className="w-100 p-3">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <h1 className="text-dark display-4 m-0">{t('Tableau_de_bord_paiements')}</h1>
            <input
              type="text"
              className="form-control w-auto"
              placeholder={t('Rechercher_par_ID')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ maxWidth: '300px' }}
            />
          </div>
          <hr className="my-4" />

          <div className="table-responsive">
            <table className="table table-striped table-hover">
              <thead className="table-primary">
                <tr>
                  <th>{t('ID_de_commande')}</th>
                  <th>{t('Fournisseur')}</th>
                  <th>{t('Paiement')}</th>
                  <th>{t('Produits')}</th>
                  <th>{t('Montant')}</th>
                  <th>{t('statut')}</th>
                  <th>{t('Cree_le')}</th>
                  <th>{t('Mis_a_jour_le')}</th>
                  <th>{t('Actions')}</th>
                </tr>
              </thead>
              <tbody>
                {orders
                  .filter((order) =>
                    searchTerm === '' || order.idsOrder.toString().includes(searchTerm)
                  )
                  .map((order) => {
                    return (
                      <tr key={order.OrderID}>
                        <td>{order.OrderID}</td>
                        <td>
                          <strong>{getTranslatedText(order.supplier?.name) || t('No_supplier')}</strong>
                          <br />
                          {t('Phone')}: {order.supplier?.phone || t('No_supplier')}
                          <br />
                          ID: {order.supplier?.custom_id || 'N/A'}
                        </td>
                        <td>
                          {t('Statut_du_paiement')}: {order.payment?.PaymentStatus}
                          <br />
                          {t('Montant_du_paiement')}: {order.payment?.Amount} DH
                          <br />
                          {t('Date_de_paiement')}:{' '}
                          {order.payment?.PaymentDate
                            ? new Date(order.payment.PaymentDate).toLocaleString()
                            : 'N/A'}
                        </td>
                        <td>
                          {order.order_items?.map((item, index) => (
                            <span key={item.OrderItemID}>
                              <strong>{getProductName(item.product.Name)} <br/>(x{item.Quantity})</strong>

                              {index < order.order_items.length - 1 && ', '}
                            </span>
                          ))}
                        </td>
                        <td>
                          <strong>{order.payment?.Amount} DH</strong>
                        </td>
                        <td>{getTranslatedText(order.status)}</td>
                        <td>{new Date(order.created_at).toLocaleString()}</td>
                        <td>{new Date(order.updated_at).toLocaleString()}</td>
                        <td>
                            <button
          className="btn btn-info"
          onClick={() => handleView(order.OrderID)}
          disabled={order.payment.PaymentStatus === 'payé' || order.status !== 'livré'} // Disable if payment status is "payé" or order status is not "livré"
          title={order.status !== 'livré' ? "Cette commande n'est pas encore livrée." : ""}
        >
           {t('Paye')}
        </button>
        <button
          className="btn btn-danger"
          onClick={() => handleDelete(order.OrderID)}
          disabled={order.payment.PaymentStatus === 'annulé'} // Disable if payment status is "annulé"
        >
           {t('Annule')}
        </button>                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-center">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${pagination.currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => handlePageChange(pagination.currentPage - 1)}>
                    {t('Previous')}
                  </button>
                </li>
                {[...Array(pagination.totalPages)].map((_, index) => (
                  <li
                    key={index}
                    className={`page-item ${pagination.currentPage === index + 1 ? 'active' : ''}`}
                  >
                    <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li className={`page-item ${pagination.currentPage === pagination.totalPages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => handlePageChange(pagination.currentPage + 1)}>
                    {t('Next')}
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </section>
      </div>
      <Footer />
    </AnimationRevealPage>
  );
};

export default PaymentAdmin;
